import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { DesktopTPPRightColumnService } from '../desktop-tpp-right-column/desktop-tpp-right-column.service';
import { BasicService } from '../../shared/services/basic.service';

/**
 * Handles opening and closing the modals that are displayed in the right-hand column in desktop mode
 */
@Injectable({
  providedIn: 'root',
})
export class TaskProcessModalsService {
  constructor(private desktopTPPRightColumnService: DesktopTPPRightColumnService, private basicService: BasicService) {}

  /**
   * Display the given modal either as a card modal (if native or mobile mode)
   * or in the right-hand side column (in desktop mode)
   */
  showTaskProcessPageModal(component, componentInput) {
    return environment.bundledWithAngularJSApp
      ? this.desktopTPPRightColumnService.displayPseudoModal(component, componentInput)
      : this.basicService.cardModal(component, componentInput);
  }

  /**
   * Close a modal that had been opened by the method above
   */
  dismissTaskProcessPageModal(data?) {
    if (environment.bundledWithAngularJSApp) {
      this.desktopTPPRightColumnService.dismissCurrentPseudoModal(data);
    } else {
      this.basicService.dismissModal(data);
    }
  }
}
